import React ,{useState,useEffect}from 'react'
import "./Register.css";
import leftArrow from "../assets/images/leftArrow.svg";
import alert from "../assets/images/alert.svg";
import { validateMobile ,validateEmail} from '../utils/validation';
import { checkForMobile } from '../../../util';

import { Trans, useTranslation } from "react-i18next";
function Register(props) {
  const { t, i18n } = useTranslation();
    let [nameVal, setName] = useState("");
    let [nameError, setNameError] = useState(false);
    let [mobileError, setMobileError] = useState("");
    let [mobileVal, setMobile] = useState(props.mobile);
    let [registerBtnEnabled, setRegisterBtnEnabled] = useState(false);
    let [emailVal , setEmail] = useState(props.email);
    let [emailError,setEmailError] = useState(false)

    useEffect(()=>{
        if (nameVal.trim().length > 2) {
            setRegisterBtnEnabled(true);
        } else {
            setRegisterBtnEnabled(false);
        }
        if(props.loginState==1){
            if (mobileVal.length > 0 && nameVal.length > 2 && !!nameVal.trim().length && emailVal.length != "" ) {// emailVal.length != "" &&
                setRegisterBtnEnabled(true);
            } else {
                setRegisterBtnEnabled(false);
            }
        }
    },[nameVal,mobileVal])

    const handleRegisterClick = () => {
        if(!nameVal || !mobileVal){
            if (!nameVal) {
                setNameError(true)
            }
            if (!mobileVal) {
                setMobileError(true)
            }
            if(!emailVal)
            setEmailError(true)
            return;
        }
        if(nameVal.trim().length<3){
            setNameError(true)   
            return;  
         }
        else if(!validateMobile(mobileVal,props.mobileRegex)){
            setMobileError(true);
            return;
         } 
        else if(!validateEmail(emailVal)){
            setEmailError(true);
            return
        }
         else{
             setNameError(false);
             setMobileError(false);
             setEmailError(false);
             let contact = {}
             if (props.mobile || mobileVal ) {
                contact.countryExt = props.CountryCode;
                contact.mobile = props.mobile ||mobileVal
            }
            if (props.email || emailVal) {
                contact.email = props.email || emailVal
            }
             let reqObj = {
                contact: {
                    ...contact
                },
                type: 1,
                name: nameVal.trim(),
                orgId: props.orgId,
                sessionId: props.generateOtp.sessionId,
                otp: props.otp,
                regViaFreeTest:1
            };
            props.registerUserAction(reqObj);
         }   
        
    }
    return (
        <div className="otp-container">
        <button
            className="otp-back-button"
            onClick={() => {
                props.setStatusAction("AccountLogin");
                props.setMobileAction("")
                setName("")
            }}
        >
            <img src={leftArrow} alt="" style={{ marginRight: "8px" }} />
            <label style={{ cursor: "pointer" }}>{t("Routes.Login.Register.back", "Back")}</label>
        </button>
        <p className="otp-heading">
          <Trans i18nKey="Routes.Login.Register.AskingNameBeforeContinue">May we know your name before you continue?</Trans>
        </p>
        <p className="otp-subheading">
          <Trans i18nKey="Routes.Login.Register.AskingNameToAddressYouInsideApp">Please enter your name that we will use to address you everywhere inside the app</Trans>
        </p>
        <p className="otp-texts">{t("Routes.Login.Register.YourName", "Your Name")} </p>
        <input
        id="otp_input"
            onChange={e => {
                setNameError(false);
                setName(e.target.value);
            }}
            className="register-profile-input"
            shouldAutoFocus={true}
            placeholder="Name"
            value={nameVal}
            style={
                nameError
                    ? { border: "1px solid #F15123" }
                    : { border: "1px solid #C4CDD5" }
            }
            autoFocus
        />
        {(nameError) ? (
            <div className="otp-error">
                <img src={alert} alt="" style={{ marginRight: "4px" }} />
                <label className="otp-error-message">
                    {t("Routes.Login.Register.PleaseFillInThisToo","Please fill in this too.")}
                </label>
            </div>
        ) : null}



                {props.loginState == 1 || props.saveUserInfoType===0 ? 
                <>
                            <div className="register-profile-mobile-field">
                                <label className="otp-texts">
                                    Your Mobile Number
                                </label>
                                <input
                                    data-cy="register_mobile"
                                    // disabled={mobile}
                                    type="number"
                                    className="register-profile-input register-profile-input-mobile"
                                    placeholder="Enter your mobile number"
                                    value={mobileVal}
                                    maxLength="10"
                                    pattern="\d{10}"
                                    style={
                                        mobileError
                                            ? { border: "1px solid #F15123" }
                                            : { border: "1px solid #C4CDD5" }
                                    }
                                    onChange={e => {
                                        setMobileError(false)
                                        const re = /^[0-9\b]+$/;
                                        if (
                                            e.target.value === "" ||
                                            re.test(e.target.value)
                                        ) {
                                            if (e.target.value.length <= 10) {
                                                setMobile(e.target.value);
                                                // setMobileAction(e.target.value)
                                            }
                                        }
                                    }}
                                />
                                <div className="register-profile-mobile-field-code">
                                    +{props.CountryCode}
                                </div>
                            </div>
                            {mobileError ? (
                                <div className="register-error">
                                    <img
                                        src={alert}
                                        alt=""
                                        style={{ marginRight: "4px" }}
                                    />
                                    <label className="register-error-message">
                                        {" "}
                                        Entered mobile number is wrong
                                    </label>
                                </div>
                            ) : null}
                        </>
                    :<> 
                    { props.saveUserInfoType === 2 || props.saveUserInfoType===1 ? 
                    <>
                        <div className="register-profile-mobile-field">
                            <label className="otp-texts">
                                Your Email Address
                            </label>
                            <input
                                data-cy="register_mobile"
                                type="email"
                                className="register-profile-input register-profile-input-email"
                                placeholder="Enter your email address"
                                value={emailVal}
                                style={
                                    emailError
                                        ? { border: "1px solid #F15123" }
                                        : { border: "1px solid #C4CDD5" }
                                }
                                onChange={e => {
                                    setEmailError(false)
                                    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                    if (
                                        e.target.value === "" ||
                                        re.test(e.target.value)
                                    ) { if (e.target.value.length > 6) {
                                        setEmail(e.target.value);
                                    }
                                    }
                                }}
                            />
                        </div>
                        {emailError ? (
                            <div className="register-error">
                                <img
                                    src={alert}
                                    alt=""
                                    style={{ marginRight: "4px" }}
                                />
                                <label className="register-error-message">
                                    {" "}
                                    Entered email address is wrong
                                </label>
                            </div>
                        ) : null}
                    </>
                    :
                    null
                    }
                </>}

        <div className="name-footer" style={props.loginState == 1 && checkForMobile() ? {marginTop:"3rem"}:{}}>
            <div className="otp-waiting-mob ">
                <span>
                {t("Routes.Login.Register.LoggingUsingCountryCodeNumber","You are logging in using ")}  &nbsp; <b>{props.loginState == 0 ? `+${props.CountryCode??""}-${props.mobile??""}` : ` ${props.email??""}`}</b>
                </span>
            </div>
            
             <button
                    className={registerBtnEnabled
                            ? "name-button-enabled"
                            : "name-button-disabled"
                    }
                    onClick={handleRegisterClick}
                    data-cy="login_verify"
                >
                   {t("Routes.Login.Register.LetsGetStarted", " Let’s Get Started")}
            </button>
        </div>
       
        <div className="otp-waiting-web">
        {t("Routes.Login.Register.LoggingUsingCountryCodeNumber","You are logging in using ")}  &nbsp;<b>{props.loginState == 0 ? `+${props.CountryCode}-${props.mobile}` : ` ${props.email??""}`}</b>
            </div>
    </div>
    )
}

export default Register